
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.3.1
 * Query Engine version: c875e43600dfe042452e0b868f7a48b817b9640b
 */
Prisma.prismaVersion = {
  client: "4.3.1",
  engine: "c875e43600dfe042452e0b868f7a48b817b9640b"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.BlockActionEventScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  blockId: 'blockId',
  blockActionId: 'blockActionId',
  values: 'values',
  consumerId: 'consumerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.BlockActionScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  config: 'config',
  blockId: 'blockId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.BlockScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  config: 'config',
  pageId: 'pageId',
  order: 'order',
  parentId: 'parentId',
  blockStateId: 'blockStateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.BlockStateScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  pageId: 'pageId',
  state: 'state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.ChatbotFeedbackScalarFieldEnum = makeEnum({
  id: 'id',
  blockId: 'blockId',
  chatbotSessionId: 'chatbotSessionId',
  chatbotConfig: 'chatbotConfig',
  conversation: 'conversation',
  message: 'message',
  rating: 'rating',
  comment: 'comment',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.ChatbotMessageScalarFieldEnum = makeEnum({
  id: 'id',
  sessionId: 'sessionId',
  role: 'role',
  content: 'content',
  meta: 'meta',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.ChatbotSessionScalarFieldEnum = makeEnum({
  id: 'id',
  blockId: 'blockId',
  chatbotConfig: 'chatbotConfig',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.ConsumerScalarFieldEnum = makeEnum({
  id: 'id',
  projectId: 'projectId',
  email: 'email',
  avatar: 'avatar',
  name: 'name'
});

exports.Prisma.DatasourceScalarFieldEnum = makeEnum({
  id: 'id',
  pageId: 'pageId',
  type: 'type',
  config: 'config',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.FormSubmissionScalarFieldEnum = makeEnum({
  id: 'id',
  blockId: 'blockId',
  recordId: 'recordId',
  tableId: 'tableId',
  values: 'values',
  consumerId: 'consumerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: Prisma.JsonNull
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
});

exports.Prisma.PageScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  title: 'title',
  slug: 'slug',
  projectId: 'projectId',
  navigationEnabled: 'navigationEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.Page_migrationsScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  applied_at: 'applied_at'
});

exports.Prisma.ProjectScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  slug: 'slug',
  customDomain: 'customDomain',
  accountId: 'accountId',
  creatorId: 'creatorId',
  appearance: 'appearance',
  password: 'password',
  secret: 'secret',
  homepageId: 'homepageId',
  embedHosts: 'embedHosts',
  authType: 'authType',
  googleAnalyticsTrackingId: 'googleAnalyticsTrackingId',
  hideZapierButton: 'hideZapierButton',
  favicon: 'favicon',
  logo: 'logo',
  globalNavigation: 'globalNavigation',
  includeLogo: 'includeLogo',
  linkedPageIds: 'linkedPageIds',
  navigationLinks: 'navigationLinks',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.RestHookSubscriptionScalarFieldEnum = makeEnum({
  id: 'id',
  url: 'url',
  accountId: 'accountId',
  projectId: 'projectId',
  pageId: 'pageId',
  blockType: 'blockType',
  blockId: 'blockId',
  blockActionId: 'blockActionId',
  blockEventType: 'blockEventType',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  zapierId: 'zapierId',
  accountIds: 'accountIds',
  isStaff: 'isStaff',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  avatarUrl: 'avatarUrl',
  planId: 'planId',
  subscriptionPending: 'subscriptionPending',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  expiresAt: 'expiresAt',
  lastSeenAt: 'lastSeenAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});
exports.BlockActionType = makeEnum({
  Navigate: 'Navigate',
  Notify: 'Notify',
  OpenExternalUrl: 'OpenExternalUrl',
  ChatbotButton: 'ChatbotButton'
});

exports.BlockEventType = makeEnum({
  ChatbotButtonClick: 'ChatbotButtonClick',
  ChatbotFeedback: 'ChatbotFeedback'
});

exports.BlockType = makeEnum({
  MarkdownText: 'MarkdownText',
  Links: 'Links',
  LinksCard: 'LinksCard',
  TableListing: 'TableListing',
  Kanban: 'Kanban',
  Form: 'Form',
  Field: 'Field',
  ZapbotPrompt: 'ZapbotPrompt',
  Chatbot: 'Chatbot',
  Media: 'Media',
  Divider: 'Divider'
});

exports.DatasourceType = makeEnum({
  ApiZap: 'ApiZap'
});

exports.ProjectAuthType = makeEnum({
  None: 'None',
  Password: 'Password',
  Consumer: 'Consumer'
});

exports.RestHookSubscriptionType = makeEnum({
  ProjectCreated: 'ProjectCreated',
  PageCreated: 'PageCreated',
  BlockCreated: 'BlockCreated',
  FormCreated: 'FormCreated',
  FormSubmissionCreated: 'FormSubmissionCreated',
  ConsumerCreated: 'ConsumerCreated',
  BlockActionEvent: 'BlockActionEvent'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Project: 'Project',
  Consumer: 'Consumer',
  Page: 'Page',
  Block: 'Block',
  BlockAction: 'BlockAction',
  BlockActionEvent: 'BlockActionEvent',
  BlockState: 'BlockState',
  Datasource: 'Datasource',
  FormSubmission: 'FormSubmission',
  ChatbotFeedback: 'ChatbotFeedback',
  ChatbotSession: 'ChatbotSession',
  ChatbotMessage: 'ChatbotMessage',
  RestHookSubscription: 'RestHookSubscription',
  page_migrations: 'page_migrations'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
